import { GETWORKORDERLISTSPAN_TYPES } from '../actions/getWorkOrderListSpan'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETWORKORDERLISTSPAN_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer